import createSvgIcon from "./utils/create_icon"

const TextSizeSmall = createSvgIcon(<path d="M7 7a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0h3v6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2V9h3a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1z" fill="currentColor" />, "TextSizeSmall")
export default TextSizeSmall
